import { Box, Button } from "@mui/material";
import colors from "../../Constants/colors";
import { useWorkspaceColors } from "../../Contexts/WorkspaceColorContext";

export interface ActionChipItem {
  label: string;
  icon: React.ComponentType<any>;
  action: () => void;
  disabled?: boolean;
}

export interface ActionChipsGridProps {
  chips: ActionChipItem[];
}

export function ActionChipsGrid({ chips }: ActionChipsGridProps) {
  const { colors: workspace } = useWorkspaceColors();

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "repeat(2, 1fr)",
          sm: "repeat(3, 1fr)",
          md: "repeat(4, 1fr)",
          lg: `repeat(${Math.min(chips.length, 6)}, 1fr)`,
          xl: `repeat(${chips.length}, 1fr)`,
        },
        gap: { xs: 1, sm: 1.5 },
        mb: 3,
      }}
    >
      {chips.map((chip) => {
        const IconComponent = chip.icon;
        return (
          <Button
            key={chip.label}
            variant="outlined"
            onClick={chip.action}
            disabled={chip.disabled}
            startIcon={
              <IconComponent
                sx={{ fontSize: { xs: "0.9rem", sm: "1rem", md: "1.2rem" } }}
              />
            }
            sx={{
              py: { xs: 0.5, sm: 0.75, md: 1 },
              px: { xs: 0.5, sm: 0.75, md: 1 },
              borderColor: colors.gray300,
              color: colors.gray700,
              bgcolor: "white",
              borderRadius: 2,
              textTransform: "none",
              fontSize: { xs: "0.6rem", sm: "0.65rem", md: "0.75rem" },
              fontWeight: 500,
              whiteSpace: "normal",
              textAlign: "center",
              lineHeight: 1.25,
              minWidth: 0,
              "&:hover": {
                bgcolor: workspace.accent,
                color: "white",
                borderColor: workspace.accent,
                "& .MuiSvgIcon-root": {
                  color: "white",
                },
              },
              "&.Mui-disabled": {
                bgcolor: colors.gray100,
                color: colors.gray400,
                borderColor: colors.gray200,
                opacity: 0.6,
              },
            }}
          >
            {chip.label}
          </Button>
        );
      })}
    </Box>
  );
}
